export enum FieldArrayActionTypes {
  SET_DATA,
  SET_PREVIOUS_DATA,
  SET_IS_DATA_ADD_ALLOWED,
  SET_EXISTING_DATA_REGISTRY
}
